import { render, staticRenderFns } from "./MessageIssue.vue?vue&type=template&id=6310a274&"
import script from "./MessageIssue.vue?vue&type=script&lang=js&"
export * from "./MessageIssue.vue?vue&type=script&lang=js&"
import style0 from "./MessageIssue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports